// extracted by mini-css-extract-plugin
export default {"container":"fevRz","videoEmbed":"B+EMU","large":"R8Nz9","title":"eGnkd","content":"OyPXL","separator":"ygp6q","metaContainer":"_5p1Ro","text":"EZHtX"};